import React from 'react'
import { Box, Typography } from '@mui/material'
import ConnectedAccountsPage from 'pages/Connect/ConnectedAccounts'

export default function Accounts() {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: 'auto' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 3 }}>
        Accounts
      </Typography>
      <ConnectedAccountsPage />
    </Box>
  )
}
